module.exports = __webpack_public_path__ + "img/Dantam Hair 04.05cb90de.jpg";